/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useState } from "react"
import { HiDocumentReport } from "react-icons/hi"
import { DateTime } from "luxon"

import { api } from "../../api/api"
import { useMotoboy } from "../../hooks/useMotoboy"
import { ModalRefusedOrder } from "../../components/Modals/RefusedOrder"
import { IoOpenOutline } from "react-icons/io5"
import { GlobalContext } from "../../context/GlobalContext"
import { OrderContext } from "../../context/OrderContext"
import { OrderDeliveryOffCanvas } from '../../components/OffcanvasOrder/orderDeliveryOffCanvas'
import { LIST_STATUS } from "../../utils/constantes"
import { numOrderFormat } from "../../utils/utils"

const INITIAL_FILTERS = {
  startDate: "",
  endDate: "",
  status: "",
  motoboyId: "",
  customerName: "",
  customerPhone: "",
  numOrder: "",
}

const INITIAL_PAGINATION = {
  page: 1,
  limit: 25,
  total: 0,
  totalPages: 0,
}

export function OrdersReporting() {
  const [orders, setOrders] = useState([])
  const [filter, setFilter] = useState(INITIAL_FILTERS)
  const [appliedFilters, setAppliedFilters] = useState(INITIAL_FILTERS)
  const [pagination, setPagination] = useState(INITIAL_PAGINATION)
  const { motoboys } = useMotoboy()
  const { openModalOrder, toggleOffCanvas, isOffCanvasOpen } = useContext(GlobalContext)
  const { selectOrder } = useContext(OrderContext)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  function updateFilter(field, value) {
    setFilter((current) => ({ ...current, [field]: value }))
  }

  async function searchOrders(page = 1, selectedFilters = filter, applyFilters = true) {
    const params = {
      page,
      limit: pagination.limit,
      ...(selectedFilters.startDate && { startDate: selectedFilters.startDate }),
      ...(selectedFilters.endDate && { endDate: selectedFilters.endDate }),
      ...(selectedFilters.status && { status: selectedFilters.status }),
      ...(selectedFilters.motoboyId && { motoboyId: selectedFilters.motoboyId }),
      ...(selectedFilters.customerName.trim() && { customerName: selectedFilters.customerName.trim() }),
      ...(selectedFilters.customerPhone.trim() && { customerPhone: selectedFilters.customerPhone.trim() }),
      ...(selectedFilters.numOrder && { numOrder: selectedFilters.numOrder }),
    }

    setLoading(true)
    setError("")

    try {
      const response = await api.get('/orders/filter', { params })
      setOrders(response.data?.data ?? [])
      setPagination(response.data?.pagination ?? INITIAL_PAGINATION)
      if (applyFilters) setAppliedFilters(selectedFilters)
    } catch (requestError) {
      setOrders([])
      setError(requestError.response?.data?.message ?? 'Não foi possível pesquisar os pedidos.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ModalRefusedOrder />
      <div>
        <div className="mt-3 p-2 bg-dark-blue-1 rounded fw-bold d-flex justify-content-between  align-items-center border mb-3">
          <p className="text-white" style={{ fontSize: '1.3rem' }}>
            <HiDocumentReport color='white' className="mb-1" size={22} />  Listagem de pedidos
          </p>
        </div>

        <div className="mt-4" style={{ width: '100%' }}>
          <form className="row border p-1 pb-3 g-2" style={{ margin: '0 auto' }} onSubmit={(event) => {
            event.preventDefault()
            searchOrders()
          }}>
            <p style={{ marginTop: 5 }} className="text-gray">Pesquisa</p>
            <div className="col-sm-6 col-md-2">
              <label htmlFor="order-start-date" className="text-gray">Início</label>
              <input id="order-start-date" type="date" value={filter.startDate} onChange={(e) => updateFilter('startDate', e.target.value)} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-6 col-md-2">
              <label htmlFor="order-end-date" className="text-gray">Fim</label>
              <input id="order-end-date" type="date" value={filter.endDate} onChange={(e) => updateFilter('endDate', e.target.value)} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-6 col-md-2">
              <label htmlFor="order-status" className="text-gray">Status</label>
              <select id="order-status" value={filter.status} onChange={(e) => updateFilter('status', e.target.value)} className="form-select form-select-sm">
                <option value="">Todos</option>
                {LIST_STATUS.map((item) => (
                  <option key={item.status} value={item.status}>{item.name}</option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 col-md-2">
              <label htmlFor="order-motoboy" className="text-gray">Motoboys</label>
              <select id="order-motoboy" value={filter.motoboyId} onChange={(e) => updateFilter('motoboyId', e.target.value)} className="form-select form-select-sm">
                <option value="">TODOS</option>
                {motoboys.map((motoboy) => (
                  <option key={motoboy.id} value={motoboy.id}>{motoboy.name}</option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 col-md-3">
              <label htmlFor="order-customer-name" className="text-gray">Nome do cliente</label>
              <input id="order-customer-name" type="text" value={filter.customerName} onChange={(e) => updateFilter('customerName', e.target.value)} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-6 col-md-2">
              <label htmlFor="order-customer-phone" className="text-gray">Telefone</label>
              <input id="order-customer-phone" type="tel" value={filter.customerPhone} onChange={(e) => updateFilter('customerPhone', e.target.value)} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-6 col-md-2">
              <label htmlFor="order-number" className="text-gray">Número do pedido</label>
              <input id="order-number" type="number" min="1" value={filter.numOrder} onChange={(e) => updateFilter('numOrder', e.target.value)} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-6 col-md-2 d-flex align-items-end">
              <button type="submit" className="btn btn-sm btn-dark-blue w-100" disabled={loading}>Pesquisar</button>
            </div>
          </form>

          {error && <div className="alert alert-danger mt-3 mb-0" role="alert">{error}</div>}

          <div className="mt-3" style={{ height: 400, maxHeight: 400, overflow: 'auto' }}>
            <table className="table table-sm" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Pedido</th>
                  <th>Cliente</th>
                  <th>Telefone</th>
                  <th>Data</th>
                  <th>Motoboy</th>
                  <th>Status</th>
                  <th>Tipo</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody style={{ width: '100%' }}>
                {!loading && orders.map((order) => (
                  <tr key={order.id}>
                    <td>{numOrderFormat(order.numOrder)}</td>
                    <td>{order.name}</td>
                    <td>{order.phone || '-'}</td>
                    <td>{DateTime.fromISO(order.createdAt).toLocal().toFormat('dd/MM/yyyy HH:mm')}</td>
                    <td>{order?.motoboy?.name ?? 'Sem entregador'}</td>
                    <td className="text-primary fw-bold">{order?.status?.capitalize().replace(/_/g, ' ') ?? '-'}</td>
                    <td className="text-success">{order?.methodDelivery?.capitalize() ?? (order?.typeOrder?.capitalize() ?? '-')}</td>
                    <td>
                      <button onClick={async () => {
                        await selectOrder(order.id)
                        openModalOrder()
                      }} className="btn btn-sm border" type="button" aria-label={`Abrir pedido ${order.numOrder}`}>
                        <IoOpenOutline />
                      </button>
                    </td>
                  </tr>
                ))}
                {!loading && orders.length === 0 && (
                  <tr><td colSpan={8} className="text-center text-muted py-4">Nenhum pedido encontrado.</td></tr>
                )}
              </tbody>
            </table>
          </div>

          {loading && (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 15, alignItems: 'center' }}>
              <h5>Carregando informações</h5>
              <div className="spinner-border mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {!loading && !error && (
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 mt-3 text-dark fw-semibold" aria-label="Paginação dos pedidos">
              <span className="text-dark">{pagination.total} pedido(s)</span>
              <div className="d-flex align-items-center gap-2">
                <button type="button" className="btn btn-sm btn-outline-dark" disabled={pagination.page <= 1} onClick={() => searchOrders(pagination.page - 1, appliedFilters, false)}>Anterior</button>
                <span className="text-dark">Página {pagination.page} de {Math.max(1, pagination.totalPages)}</span>
                <button type="button" className="btn btn-sm btn-outline-dark" disabled={pagination.page >= pagination.totalPages} onClick={() => searchOrders(pagination.page + 1, appliedFilters, false)}>Próxima</button>
              </div>
            </div>
          )}
        </div>
      </div>
      <OrderDeliveryOffCanvas
        isOffCanvasOpen={isOffCanvasOpen}
        toggleOffCanvas={toggleOffCanvas}
      />
    </>
  )
}


